module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_vm._v("List of Plates")])]), _c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_c('p', {
    staticClass: "common"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "list1"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/22_chapter044#plate1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Garnet Wolseley. (Taylor Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter045#plate2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Field Marshal Sir Evelyn Wood. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter046#plate3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Redvers Buller. (Taylor Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter047#plate4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Charles Gordon. (Taylor Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter048#plate5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. George Colley. (The Royal Collection © HM Queen Elizabeth II)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter049#plate6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Caricature of Lord Chelmsford. (Private collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter0410#plate7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Lord Chelmsford. (Private collection of Kim Thesiger, 4th Viscount ….. Chelmsford)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter0411#plate8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Frederick Roberts, General the Hon. Sir Arthur Hardinge and General Sir Donald Stewart. (Taylor Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter0412#plate9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Frederick Roberts. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter0413#plate10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Herbert Kitchener. (Taylor Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter0414#plate11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Herbert Kitchener. (The National Army Museum)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af000dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_plates.vue
// module id = 72
// module chunks = 0